import {css, StyleSheet} from 'aphrodite';
import * as React from 'react';
import {ReactNode} from 'react';

export interface AssemblyParametersControlsLayoutProps {
  controls: Array<ReactNode>;
}

/**
 * A flexbox-based two-column layout for displaying assembly controls.
 *
 * @param props Component props
 * @param props.controls A list of control elements. Will be displayed two per row. When an odd number of controls is provided, a wrapper around the last component will flex-grow to fill the entire width.
 * @constructor
 */
export function AssemblyParametersControlsLayout(props: AssemblyParametersControlsLayoutProps): JSX.Element {
  // Chunk the array of controls into rows of two controls each.
  const controlsByRow = [];
  const rowSize = 2;
  for (let i = 0; i < props.controls.length; i += rowSize) {
    controlsByRow.push(props.controls.slice(i, i + rowSize));
  }

  return (
    <div>
      {controlsByRow.map((row, index) => {
        const [firstColumn, secondColumn] = row;
        const secondColumnStyles = secondColumn != null ? [styles.column] : [styles.emptySecondColumn];
        return (
          <div className={css(styles.row)} key={index}>
            <div className={css(styles.column)}>{firstColumn}</div>
            {secondColumn && <div className={css(styles.spacer)} />}
            <div className={css(...secondColumnStyles)}>{secondColumn && secondColumn}</div>
          </div>
        );
      })}
    </div>
  );
}

const styles = StyleSheet.create({
  row: {
    display: 'flex',
    marginTop: '16px',
  },
  column: {
    flex: 1,
  },
  spacer: {
    width: '22px',
  },
  emptySecondColumn: {
    flex: '0 1 0%',
  },
});
